import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const orgListSlice = createSlice({
  name: 'orgList',
  initialState,
  reducers: {
    upsertOrgs: (state, action) => {
      const payload = action.payload;
      if (!payload || typeof payload !== 'object') return;
      Object.keys(payload).forEach((id) => {
        if (payload[id] && typeof payload[id] === 'object') {
          state[id] = { ...(state[id] || {}), ...payload[id] };
        }
      });
    },
    clearOrgs: () => initialState,
  },
});

export const { upsertOrgs, clearOrgs } = orgListSlice.actions;

export const selectOrgList = (state) => state.orgList;
export const selectOrgById = (id) => (state) =>
  (id != null && state.orgList ? state.orgList[id] : undefined);

export default orgListSlice.reducer;
